import {
	shellTokens,
	type HeaderShellToken,
	type SidebarShellToken,
} from './tokens';

export const CSS_VAR = {
	header: {
		background: '--psda-header-bg',
		foreground: '--psda-header-foreground',
		icon: '--psda-header-icon',
		border: '--psda-header-border',
	},
	sidebar: {
		headerBackground: '--psda-sidebar-header-bg',
		headerBorder: '--psda-sidebar-header-border',
		headerBorderWidth: '--psda-sidebar-header-border-width',
		primary: '--psda-sidebar-primary',
		foreground: '--psda-sidebar-foreground',
		navActiveBg: '--psda-sidebar-nav-active-bg',
		navActiveForeground: '--psda-sidebar-nav-active-fg',
		navActiveIcon: '--psda-sidebar-nav-active-icon',
		navActiveIndicator: '--psda-sidebar-nav-active-indicator',
		navHoverBg: '--psda-sidebar-nav-hover-bg',
		border: '--psda-sidebar-border',
		scrollbarThumb: '--psda-sidebar-scrollbar-thumb',
		scrollbarTrack: '--psda-sidebar-scrollbar-track',
		toggleBackground: '--psda-sidebar-toggle-bg',
		toggleHover: '--psda-sidebar-toggle-hover',
		toggleForeground: '--psda-sidebar-toggle-fg',
	},
} as const;

const sidebarTokenToCssVar: Record<SidebarShellToken, string> = {
	headerBackground: CSS_VAR.sidebar.headerBackground,
	headerBorder: CSS_VAR.sidebar.headerBorder,
	headerBorderWidth: CSS_VAR.sidebar.headerBorderWidth,
	primary: CSS_VAR.sidebar.primary,
	foreground: CSS_VAR.sidebar.foreground,
	navActiveBg: CSS_VAR.sidebar.navActiveBg,
	navActiveForeground: CSS_VAR.sidebar.navActiveForeground,
	navActiveIcon: CSS_VAR.sidebar.navActiveIcon,
	navActiveIndicator: CSS_VAR.sidebar.navActiveIndicator,
	navHoverBg: CSS_VAR.sidebar.navHoverBg,
	border: CSS_VAR.sidebar.border,
	scrollbarThumb: CSS_VAR.sidebar.scrollbarThumb,
	scrollbarTrack: CSS_VAR.sidebar.scrollbarTrack,
	toggleBackground: CSS_VAR.sidebar.toggleBackground,
	toggleHover: CSS_VAR.sidebar.toggleHover,
	toggleForeground: CSS_VAR.sidebar.toggleForeground,
};

const headerTokenToCssVar: Record<HeaderShellToken, string> = {
	background: CSS_VAR.header.background,
	foreground: CSS_VAR.header.foreground,
	icon: CSS_VAR.header.icon,
	border: CSS_VAR.header.border,
};

export function getShellCssVariables(): Record<string, string> {
	const sidebarVars = Object.fromEntries(
		(Object.keys(sidebarTokenToCssVar) as SidebarShellToken[]).map((key) => [
			sidebarTokenToCssVar[key],
			shellTokens.sidebar[key],
		]),
	);

	const headerVars = Object.fromEntries(
		(Object.keys(headerTokenToCssVar) as HeaderShellToken[]).map((key) => [
			headerTokenToCssVar[key],
			shellTokens.header[key],
		]),
	);

	return { ...sidebarVars, ...headerVars };
}
